import { isDeviationPixelArt, isFileLargerThanSize } from '../../../_helpers';
import { useDeviationViewContext } from '../../../../Context';
import { useContext, useMemo } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ddt from '@wix/da-ddt';
import DeviationMediaService from '../../../../utils/DeviationMediaService';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
export function useFullview({ stageWidth, stageHeight, deviation }) {
    const isMobile = useContext(MobileContext);
    const { device } = useContext(SessionContext);
    const { isFullscreen } = useDeviationViewContext();
    const hasSrc = !!DeviationMediaService.getLargestFullview(deviation);
    const hasPreview = !!DeviationMediaService.getDeviationFile(deviation, 'preview');
    const isPreviewable = hasPreview && hasSrc;
    const { src, srcSet, sizes, previewFile, srcFile } = useMemo(()=>{
        if (!isPreviewable) {
            return {};
        }
        return DeviationMediaService.getSrcSetForDeviationPreview(deviation, isMobile, isMobile && !(device === null || device === void 0 ? void 0 : device.isTablet) ? '100vw' : '(min-width: 1152px) 70vw, 100vw');
    }, // We only want this to be done once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        deviation.deviationId
    ]);
    // Non images don't have anything to show
    if (!isPreviewable) {
        return {};
    }
    const isGif = DeviationMediaService.isGif(deviation);
    const isPixel = isDeviationPixelArt(deviation);
    const isBiggerThanStage = !!srcFile && // must have a fullview
    !isGif && // must not be a gif as selecting sized one will give you static jpg sometimes
    isFileLargerThanSize(srcFile, stageWidth, stageHeight); // must be larger than the artstage
    var _srcFile_filesize;
    // Large gif handling, must have a non-gif preview, 5MB Mobile only
    const isLargeGif = isGif && /\.jpg\?/.test(previewFile.src) && isMobile && ((_srcFile_filesize = srcFile === null || srcFile === void 0 ? void 0 : srcFile.filesize) !== null && _srcFile_filesize !== void 0 ? _srcFile_filesize : 0) > 5242880;
    // Remove the srcset if its a gif and we are not showing the playbutton
    const calcSrcSet = isGif && !isLargeGif ? '' : srcSet;
    ddt.log('deviation', 'Using fullview attr', {
        src,
        srcSet,
        sizes,
        previewFile,
        srcFile
    });
    return {
        previewFile,
        srcFile,
        srcSet: calcSrcSet,
        sizes,
        src,
        isPixel,
        isFullscreen,
        canZoom: isBiggerThanStage,
        isGif,
        isLargeGif
    };
}
